import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const RoleTableTabIcon = ({
  width = "26",
  height = "26",
  color = "#B3B3B3",
  rotate,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} rotate={rotate}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 27 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.25 3.25H5.91667C5.34203 3.25 4.79093 3.47827 4.3846 3.8846C3.97827 4.29093 3.75 4.84203 3.75 5.41667V9.75M10.25 3.25H21.0833C21.658 3.25 22.2091 3.47827 22.6154 3.8846C23.0217 4.29093 23.25 4.84203 23.25 5.41667V9.75M10.25 3.25V22.75M3.75 9.75V20.5833C3.75 21.158 3.97827 21.7091 4.3846 22.1154C4.79093 22.5217 5.34203 22.75 5.91667 22.75H10.25M3.75 9.75H23.25M23.25 9.75V20.5833C23.25 21.158 23.0217 21.7091 22.6154 22.1154C22.2091 22.5217 21.658 22.75 21.0833 22.75H10.25"
          stroke={color}
          strokeWidth="2.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  );
};
